import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import PartnerDetailInfoSkeleton from '@components/PartnerGroup/Skeleton/PartnerDetailInfoSkeleton';
import PartnerGroupPerformanceSkeleton from '@components/PartnerGroup/Skeleton/PartnerGroupPerformanceSkeleton';
import PartnerInvestSummarySkeleton from '@components/PartnerGroup/Skeleton/PartnerInvestSummarySkeleton';
import PartnerPortfolioListSkeleton from '@components/PartnerGroup/Skeleton/PartnerPortfolioListSkeleton';

const PartnerDetailInfo = lazy(
  () => import('@components/PartnerGroup/PartnerDetailInfo')
);
const PartnerGroupInvestSummary = lazy(
  () => import('@components/PartnerGroup/PartnerGroupInvestSummary')
);
const PartnerGroupPerformance = lazy(
  () => import('@components/PartnerGroup/PartnerGroupPerformance')
);
const PartnerPortfolioList = lazy(
  () => import('@components/PartnerGroup/PartnerPortfolioList')
);

/** 파트너 계정: 조합 관리 > 상세 */
const PartnerGroupDetail = () => {
  return (
    <>
      {/* 조합 상세정보 */}
      <ApiErrorBoundary>
        <Suspense fallback={<PartnerDetailInfoSkeleton />}>
          <PartnerDetailInfo />
        </Suspense>
      </ApiErrorBoundary>

      {/* 투자정보 */}
      <ApiErrorBoundary>
        <Suspense fallback={<PartnerInvestSummarySkeleton />}>
          <PartnerGroupInvestSummary />
        </Suspense>
      </ApiErrorBoundary>

      {/* 조합 실적 */}
      <ApiErrorBoundary>
        <Suspense fallback={<PartnerGroupPerformanceSkeleton />}>
          <PartnerGroupPerformance />
        </Suspense>
      </ApiErrorBoundary>

      {/* 포트폴리오사 목록 */}
      <ApiErrorBoundary>
        <Suspense fallback={<PartnerPortfolioListSkeleton />}>
          <PartnerPortfolioList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default PartnerGroupDetail;
